import Assignees from '@/constants/Assignees';
import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';
import type ConstituentFilterFormData from '../types/ConstituentFilterFormData';
import TemporaryFilterField from './TemporaryFilterField';

const ConstituentSearchDefaultValues: ConstituentFilterFormData = {
  // Constituent
  [ConstituentSearchFilterField.NAME_EMAIL_PHONE]: '',
  [ConstituentSearchFilterField.CONSTITUENT_CATEGORIES]: [],
  [ConstituentSearchFilterField.CONSTITUENT_TYPE]: null,
  [TemporaryFilterField.ASSIGNEE]: Assignees.ALL,
  [TemporaryFilterField.CONSTITUENT_LABELS]: [],
  // Extended constituent
  [ConstituentSearchFilterField.CITY]: '',
  [ConstituentSearchFilterField.STATE]: '',
  [ConstituentSearchFilterField.POSTAL_CODE]: '',
  [ConstituentSearchFilterField.BIRTHDAY_MONTH]: '',
  [TemporaryFilterField.BORN_DATE_RANGE]: [],
  [TemporaryFilterField.CONNECTION_CONSTITUENT]: undefined,
  [TemporaryFilterField.CUSTOM_FIELDS]: {},

  // Contribution
  [ConstituentSearchFilterField.DONATION_TYPES]: [],
  [TemporaryFilterField.CONTRIBUTION_LABELS]: [],
  [TemporaryFilterField.DONATION_AMOUNT_RANGE]: [],
  [TemporaryFilterField.DONATION_HOURS_RANGE]: [],
  // Extended contribution
  [ConstituentSearchFilterField.CAMPAIGN_IDS]: [],
  [ConstituentSearchFilterField.DONATION_DATE_TYPE]: '',
  [TemporaryFilterField.DONATION_DATE_RANGE]: [],

  // IWave
  [ConstituentSearchFilterField.IWAVE_AFFINITY_SCORE]: '',
  [ConstituentSearchFilterField.IWAVE_CAPACITY_SCORE]: '',
  [ConstituentSearchFilterField.IWAVE_PLANNED_GIVING_SCORE]: '',
  [ConstituentSearchFilterField.IWAVE_PROPENSITY_SCORE]: '',
  [ConstituentSearchFilterField.IWAVE_SCORE]: '',
};

export default ConstituentSearchDefaultValues;
